export default __webpack_public_path__ + "static/media/happy-school-img1.b42d2963.png";